import React, { useEffect, useRef, useState } from 'react';
import CDPageLiveCount from '../../StoreCategoryPage/CDPageLiveCount';
import {
  convertToLocaleFormat,
  format_locale_date_ind,
  getIndexChangeArr,
  isInViewport,
} from '../../../Constants/B2G1CategoryPage';
import { babiesPerMinute, getTotalBabiesBorn } from './common';

function BabiesCounter(props) {
  const [elementInViewport, setElementInViewport] = useState(false);
  const [pageLiveCountValue, setPageLiveCountValue] = useState(0);
  const [changedIndexes, setChangedIndexes] = useState([]);

  const liveCountRef = useRef(null);
  const timerRef = useRef('');

  const updateLiveCount = () => {
    setPageLiveCountValue((prev) => prev + 1);
    let num1 = convertToLocaleFormat(
      pageLiveCountValue,
      format_locale_date_ind,
    ).split('');

    let num2 = convertToLocaleFormat(
      pageLiveCountValue + 1,
      format_locale_date_ind,
    ).split('');

    let index_change = getIndexChangeArr(num1, num2);
    setChangedIndexes(index_change);
    setTimeout(() => {
      setChangedIndexes([]);
    }, [2000]);
  };

  useEffect(() => {
    if (pageLiveCountValue) {
      clearTimeout(timerRef.current);
      // one baby in 6 sconds
      const timer = babiesPerMinute * 1000;
      timerRef.current = setTimeout(updateLiveCount, [timer]);
    }
  }, [pageLiveCountValue]);

  useEffect(() => {
    function scrollUpOrDown() {
      const isInViewPort = isInViewport(liveCountRef.current);
      if (isInViewPort === true) setElementInViewport(isInViewPort);
    }

    window.addEventListener('scroll', scrollUpOrDown);
    setPageLiveCountValue(getTotalBabiesBorn());
    return () => {
      window.removeEventListener('scroll', scrollUpOrDown);
    };
  }, []);

  useEffect(() => {
    if (elementInViewport) updateLiveCount();
  }, [elementInViewport]);

  return pageLiveCountValue ? (
    <CDPageLiveCount
      pageLiveCountValue={pageLiveCountValue}
      changedIndexes={changedIndexes}
      description={'Mylo Babies born this month so far'}
      liveCountRef={liveCountRef}
      happyTuesday={true}
    />
  ) : null;
}

export default BabiesCounter;
